import React from "react";
import { SRLWrapper } from "simple-react-lightbox";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Burc() {
  const { t } = useTranslation();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <SRLWrapper>
      <section
        id="portfolio-details"
        className="portfolio-details"
        aria-labelledby="burc-title"
      >
        <div className="container">
          <div className="row gy-4">

            {/* ÜRÜN NAVİGASYONU */}
            <div className="col-lg-12">
              <ul className="nav nav-tabs flex-direction justify-content-center">

                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/civata"
                    onClick={scrollToTop}
                  >
                    {t("Özel Üretim Civatalar")}
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/pim"
                    onClick={scrollToTop}
                  >
                    {t("Özel Üretim Pimler")}
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/pirinc"
                    onClick={scrollToTop}
                  >
                    {t("Özel Üretim Pirinç Parçalar")}
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    className="nav-link active show"
                    to="/burc"
                    onClick={scrollToTop}
                    aria-current="page"
                  >
                    {t("Özel Üretim Burçlar")}
                  </Link>
                </li>

              </ul>
            </div>

            {/* ÜRÜN GÖRSELİ */}
            <div className="col-lg-5">
              <div className="portfolio-details-slider swiper">
                <div className="swiper-wrapper align-items-center">

                  <div className="swiper-slide">
                    <picture>
                      <source
                        srcSet="/assets/img/Aypinautomat/burc1.webp"
                        type="image/webp"
                      />

                      <img
                        src="/assets/img/Aypinautomat/burc1.webp"
                        alt={t("Özel Üretim Burçlar")}
                        title={t("Özel Üretim Burçlar")}
                        loading="lazy"
                        decoding="async"
                        sizes="(min-width: 992px) 50vw, 100vw"
                      />
                    </picture>
                  </div>

                </div>

                <div className="swiper-pagination"></div>
              </div>
            </div>

            {/* ÜRÜN AÇIKLAMASI */}
            <div className="col-lg-7">
              <div className="portfolio-description p-0">

                <h2
                  id="burc-title"
                  style={{
                    color: "#0000FF",
                    textAlign: "center",
                  }}
                >
                  {t("Özel Üretim Burçlar")}
                </h2>

                <div style={{ textAlign: "justify" }}>

                  <p>
                    {t("Burc.Para1")}
                  </p>

                  <p>
                    {t("Burc.Para2")}
                  </p>

                  <p>
                    {t("Burc.Para3")}
                  </p>

                  <Link
                    to="/iletisim"
                    onClick={scrollToTop}
                    className="btn-get-started"
                  >
                    {t("Burc.MoreInfo")}
                  </Link>

                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </SRLWrapper>
  );
}

export default Burc;